import { Modal, Upload, UploadFile } from "antd";
import { useEffect, useState } from "react";
import { PlusOutlined } from '@ant-design/icons';
import { getBase64 } from "./utils";

interface Props {
    placeholder: string
    onChangeFilesList: (filesList: UploadFile[]) => void
    maxFiles?: number
    initialFiles?: UploadFile[]
}

export const UploadComponent = (props: Props) => {
    const maxFiles: number = props.maxFiles || 1

    const [fileList, setFileList] = useState<UploadFile[]>([])
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    // const [hasImageChanged, setHasImageChanged] = useState<boolean>(false)

    useEffect(() => {
        if (props.initialFiles && props.initialFiles.length > 0) {
            setFileList(props.initialFiles)
        }
    }, [props.initialFiles])

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleChange = ({ fileList: newFileList }: any) => {
        setFileList(newFileList);
        props.onChangeFilesList(newFileList)
    };

    const beforeUpload = (file: any) => {
        const allowedImageTypes: string[] = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "image/webp",
        ]

        const isAllowed = allowedImageTypes.includes(file.type);
        if (!isAllowed) {
            alert(`El formato ${file.type} de la imágen seleccionada no es permitido`);
        }

        // TODO: HANDLE THIS
        // setHasImageChanged(true)

        return isAllowed || Upload.LIST_IGNORE;
    };

    return (
        <div className="flex flex-col items-start justify-start">
            <Upload
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                beforeUpload={beforeUpload}
                showUploadList={{ showRemoveIcon: true }}
                customRequest={({ file, onSuccess }) => {
                    if (file) {
                        setTimeout(() => {
                            if (onSuccess)
                                onSuccess("ok");
                        }, 0);
                    }
                }}
            >
                {
                    (fileList.length >= maxFiles)
                        ? null
                        : <div><PlusOutlined /><div style={{ marginTop: 8 }}>
                            {props.placeholder}
                        </div></div>}
            </Upload>
            {

            }
            <Modal open={previewOpen} footer={null} onCancel={() => setPreviewOpen(false)}>
                <img alt="preview" style={{ width: '100%' }} src={previewImage} />
            </Modal>
        </div>
    )
}
